import React from 'react';
import Sidebar from './Sidebar';

interface PageLayoutProps {
  children: React.ReactNode;
  activeRoute: string;
  /** Remove padding and overflow — use for full-height flex layouts like IACoach */
  bare?: boolean;
}

export default function PageLayout({ children, activeRoute, bare = false }: PageLayoutProps) {
  return (
    <div
      style={{
        display: 'flex',
        minHeight: '100vh',
        background: '#0d0d0d',
      }}
    >
      <Sidebar activeRoute={activeRoute} />
      <main
        style={{
          flex: 1,
          marginLeft: 220,
          padding: bare ? 0 : 32,
          overflowY: bare ? 'hidden' : 'auto',
          minHeight: '100vh',
        }}
      >
        {children}
      </main>
    </div>
  );
}
